import { Box, Typography } from "@mui/material";
import fabricHero from "../../../assets/shared/fabric-hero.jpg";
import "./styles.scss";

export const MaterialHero = ({ title }: { title: string }) => {
  return (
    <Box
      className="material-hero"
      style={{ backgroundImage: `url(${fabricHero})` }}
    >
      <div className="site-wrapper">
        <Typography
          variant={"display2" as any}
          component="h1"
          className="title"
        >
          {title}
        </Typography>
      </div>
    </Box>
  );
};
